import React, { useState } from "react";
import "./ToolTip.scss";
export interface Props {
  tootTipContent: any;
  tooltipLabel: any;
  tooltipClass?: any;
  tooltipId?: any;
  tooltipClick?: any;
  tooltipStyle?: React.CSSProperties;
  tooltipContentStyle?: React.CSSProperties;
  tooltipBtnStyle?: React.CSSProperties;
}
const ToolTip = ({
  tootTipContent,
  tooltipLabel,
  tooltipClass,
  tooltipId,
  tooltipClick,
  tooltipStyle,
  tooltipContentStyle,
  tooltipBtnStyle
}: Props) => {
  const [ttOpen, setTTOpen] = useState(false);

  return (
    <div className={`mfg-toolTip${ttOpen ? " open" : ""}`} style={tooltipStyle && tooltipStyle}>
      <button
        className={`ttBtn${tooltipClass ? " " + tooltipClass : ""}`}
        id={tooltipId}
        onClick={tooltipClick || (() => setTTOpen(!ttOpen))}
        style={tooltipBtnStyle && tooltipBtnStyle}
      >
        {tooltipLabel ? tooltipLabel:<span></span>}
      </button>
      <div className={`ttContent`} style={tooltipContentStyle && tooltipContentStyle}>{tootTipContent}</div>
    </div>
  );
};

export default ToolTip;
